/**
 * ViewModeToggle Component
 * Toggle between grid and list view modes
 */
import React from 'react';
import { Button } from '../ui/button';
import { Grid, List } from 'lucide-react';

const ViewModeToggle = ({
  viewMode,
  onViewModeChange,
  className = "hidden sm:flex space-x-1"
}) => {
  return (
    <div className={className}>
      <Button
        variant={viewMode === 'grid' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('grid')}
        data-testid="view-mode-grid"
      >
        <Grid className="h-4 w-4" />
      </Button>
      <Button
        variant={viewMode === 'list' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewModeChange('list')}
        data-testid="view-mode-list"
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ViewModeToggle;
